import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

export function DeleteEmployeeModal({ isOpen, onConfirm, onCancel, employee }) {
  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent className="sm:max-w-[400px] p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="text-center text-lg font-semibold text-gray-900">Delete Employee</DialogTitle>
          <DialogDescription className="text-center pt-4">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
            <div className="text-lg font-medium text-gray-900 mb-2">Are you sure?</div>
            <div className="text-sm text-gray-500">
              {employee ? (
                <>
                  Do you really want to delete <span className="font-semibold text-gray-700">"{employee.name}"</span> (
                  {employee.role})?
                  <br />
                  This action cannot be undone.
                </>
              ) : (
                "Do you really want to delete this employee? This action cannot be undone."
              )}
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="px-6 pb-6 flex justify-center gap-3 sm:justify-center">
          <Button onClick={onCancel} variant="outline" className="px-6 py-2 text-sm font-medium">
            Cancel
          </Button>
          <Button onClick={onConfirm} className="px-6 py-2 text-sm font-medium bg-red-600 hover:bg-red-700 text-white">
            Delete Employee
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}